import { Box, styled, Typography } from '@mui/material';

export const HeaderRow = styled(Box)(({
  theme
}) => ({
  display: "grid",
  gridTemplateColumns: '40% 31% 29%',
  gap: theme.spacing(1),
  justifyContent: "center",
  alignItems: "center",
  mb: theme.spacing(2),
}));

export const ButtonBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const DataGridCell = styled(Typography)(({
  theme
}) => ({
  marginLeft: theme.spacing(3),
  variant: theme.typography.body1
}),
) as typeof Typography;

export function quantityWithCommas(quantityInput: number | null) {
  return quantityInput?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}